import { render } from "./BaseSpinner.vue?vue&type=template&id=8101fef4&scoped=true"
const script = {}

import "./BaseSpinner.vue?vue&type=style&index=0&id=8101fef4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8101fef4"
/* hot reload */
if (module.hot) {
  script.__hmrId = "8101fef4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8101fef4', script)) {
    api.reload('8101fef4', script)
  }
  
  module.hot.accept("./BaseSpinner.vue?vue&type=template&id=8101fef4&scoped=true", () => {
    api.rerender('8101fef4', render)
  })

}

script.__file = "src/ui/BaseSpinner.vue"

export default script